export type Experiment = {
    activateOnPageLoad: boolean;
    name: string;
    variations: {
        Original: string;
        VariationB: string;
        [key: string]: string;
    };
};

export const BuyNow: Experiment = {
    activateOnPageLoad: false,
    name: 'buy_now',
    variations: {
        Original: 'original',
        VariationB: 'variation_b',
    },
};

export const experiments: Experiment[] = [BuyNow];
